import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { MpSnackbarService } from '../../ui-components/mp-snackbar/mp-snackbar.service';
import { AuthenticationService } from '../../services/authentication.service';

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  const snackBarService = inject(MpSnackbarService);
  const authenticationService = inject(AuthenticationService);

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (authenticationService.isUrlInAuthorizedUrls(request.url)) {
        switch (err.status) {
          case 400:
            snackBarService.openSnackBarError('ERRORS.HTTP_ERROR_400');
            break;
          case 401:
            snackBarService.openSnackBarError('ERRORS.HTTP_ERROR_401');
            authenticationService.logout();
            break;
          case 403:
            snackBarService.openSnackBarError('ERRORS.HTTP_ERROR_403');
            authenticationService.logout();
            break;
          case 404:
            snackBarService.openSnackBarError('ERRORS.HTTP_ERROR_404');
            break;
          default:
            snackBarService.openSnackBarError('ERRORS.HTTP_ERROR_DEFAULT');
            break;
        }
      }
      return throwError(() => err.error);
    })
  );
}

